var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var _EventNotificationApi_jwt, _EventNotificationApi_ws, _EventNotificationApi_nonce, _EventNotificationApi__pathsListened, _EventNotificationApi_pathsErrors, _EventNotificationApi_idSetIntervalPing, _EventNotificationApi_tempPaths, _EventNotificationApi_countCnxFailure, _EventNotificationApi_funcPingOk, _EventNotificationApi_funcPingFail, _EventNotificationApi_observersList, _EventNotificationApi_observersListContainer, _EventNotificationApi_id, _EventNotificationApi_onMsg, _EventNotificationApi_onOp, _EventNotificationApi_onCl;
export class EventNotificationApi {
    constructor() {
        // JWT used for authentication
        _EventNotificationApi_jwt.set(this, "");
        // Websocket connection used to receive notifications
        _EventNotificationApi_ws.set(this, null);
        // Nonce associated with the connection. Is needed to update paths in existing connection.
        _EventNotificationApi_nonce.set(this, "");
        // The list of the paths listened by this instance. It's updated each time an async call is successful.
        _EventNotificationApi__pathsListened.set(this, []);
        // The list of the paths rejected by the server. It's updated each time an async call is successful.
        _EventNotificationApi_pathsErrors.set(this, []);
        // id setInterval ping (in ms)
        _EventNotificationApi_idSetIntervalPing.set(this, null
        // Paths not yet processed by tge backend
        );
        // Paths not yet processed by tge backend
        _EventNotificationApi_tempPaths.set(this, new Set()); // function ping success
        _EventNotificationApi_countCnxFailure.set(this, 0);
        _EventNotificationApi_funcPingOk.set(this, void 0);
        _EventNotificationApi_funcPingFail.set(this, void 0);
        // list of observers
        _EventNotificationApi_observersList.set(this, new Map());
        _EventNotificationApi_observersListContainer.set(this, new Map());
        this.lastPing = null;
        this.pingReceived = true;
        _EventNotificationApi_id.set(this, 0);
        _EventNotificationApi_onMsg.set(this, (ev) => {
            this.notifyEventNotification(ev.data);
        });
        _EventNotificationApi_onOp.set(this, () => {
            console.debug("WS open");
        });
        _EventNotificationApi_onCl.set(this, () => {
            console.debug("WS close");
        }
        /**
         * The list of the paths listened by this instance. It's updated each time an async call is successful.
         * Return a deep copy.
         */
        );
    }
    static get URL() {
        return this._URL;
    }
    static set URL(value) {
        this._URL = value;
    }
    // get ping interval in ms
    static get PING_INTERVAL() {
        return this._PING_INTERVAL;
    }
    // set ping interval in ms
    static set PING_INTERVAL(value) {
        if (value < 3000)
            throw new Error("Ping interval must be greater than 3s (3000 ms)");
        this._PING_INTERVAL = value;
    }
    static get RETRY_AFTER_X_FAILURE() {
        return this._RETRY_AFTER_X_FAILURE;
    }
    // set ping interval in ms
    static set RETRY_AFTER_X_FAILURE(value) {
        const valAsInt = parseInt(value.toString(), 10);
        if (isNaN(valAsInt) || valAsInt < 2)
            throw Error("Invalid input");
        this._RETRY_AFTER_X_FAILURE = valAsInt;
    }
    computeLastPing(data) {
        return {
            clientToServer: data.clientToServer,
            requestAt: data.sendAt - data.clientToServer,
            serverToClient: Date.now() - data.sendAt
        };
    }
    /**
     * The list of the paths listened by this instance. It's updated each time an async call is successful.
     * Return a deep copy.
     */
    get pathsListened() {
        return JSON.parse(JSON.stringify(__classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f")));
    }
    refreshToken(jwt) {
        return __awaiter(this, void 0, void 0, function* () {
            if (jwt === null)
                jwt = "";
            if (jwt === __classPrivateFieldGet(this, _EventNotificationApi_jwt, "f"))
                return;
            if (jwt.match(/[\n\r]/g)) {
                // Prevent HTTP header injection.
                console.error("Line break detected. Update cancelled.");
                return Promise.reject({
                    status: 1003,
                    reason: "Malformed JWT"
                });
            }
            else {
                __classPrivateFieldSet(this, _EventNotificationApi_jwt, jwt, "f");
                if (!this.isWebsocketOpen() && jwt.length > 0) {
                    yield this.connectWithStrings(__classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f")).then(r => console.debug("Refresh token open wss. " + r));
                }
            }
        });
    }
    onOpen(callback) {
        if (__classPrivateFieldGet(this, _EventNotificationApi_ws, "f") !== null) {
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").onopen = callback;
        }
        __classPrivateFieldSet(this, _EventNotificationApi_onOp, callback, "f");
    }
    onClose(callback) {
        if (__classPrivateFieldGet(this, _EventNotificationApi_ws, "f") !== null) {
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").onclose = callback;
        }
        __classPrivateFieldSet(this, _EventNotificationApi_onCl, callback, "f");
    }
    /**
     * If the library receive the ping correctly, this function will be triggered each ping interval.
     * @param callback actions to do
     */
    onPingSuccess(callback) {
        __classPrivateFieldSet(this, _EventNotificationApi_funcPingOk, callback, "f");
    }
    /**
     * If the library doesn't receive the ping correctly, this function will be triggered each ping interval.
     * @param callback actions to do
     */
    onPingFailure(callback) {
        __classPrivateFieldSet(this, _EventNotificationApi_funcPingFail, callback, "f");
    }
    sendPing() {
        var _a;
        if (this.isWebsocketOpen()) {
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").send(Date.now().toString());
        }
        if (this.pingReceived) {
            __classPrivateFieldGet(this, _EventNotificationApi_funcPingOk, "f").call(this, this.lastPing);
            __classPrivateFieldSet(this, _EventNotificationApi_countCnxFailure, 0, "f");
            this.pingReceived = false;
        }
        else {
            __classPrivateFieldSet(this, _EventNotificationApi_countCnxFailure, (_a = __classPrivateFieldGet(this, _EventNotificationApi_countCnxFailure, "f"), _a++, _a), "f");
            __classPrivateFieldGet(this, _EventNotificationApi_funcPingFail, "f").call(this);
        }
        this.tryAgain();
    }
    logout() {
        return __awaiter(this, void 0, void 0, function* () {
            let id = -1;
            if (__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f") !== null) {
                clearInterval(__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f"));
            }
            const res = yield fetch(EventNotificationApi.HTTP_PROTOCOL + EventNotificationApi._URL + EventNotificationApi.LOGOUT_ENDPOINT + id, {
                method: "POST",
                headers: this.generateFetchHeaders(),
                credentials: "same-origin"
            }).then(response => this.handle401(response));
            if (!res.ok) {
                return Promise.reject({
                    status: res.status,
                    reason: yield res.text()
                });
            }
        });
    }
    /**
     * Create a new connection from a list of paths (as String)
     * @param paths array of paths (string)
     * @return Promise with the list of denied paths
     * @private
     */
    connectWithStrings(paths = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const p = new FormData();
            p.set(EventNotificationApi.SET_VALUES_PARAMETER, paths.join(','));
            return this.initCall(p);
        });
    }
    connect(paths = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const listPaths = this.pathsTreatment(paths);
            return this.connectWithStrings(listPaths);
        });
    }
    /**
     * Return a promise reject with error code 1001.
     * @private
     */
    rejectNoNonce() {
        return __awaiter(this, void 0, void 0, function* () {
            return Promise.reject({
                status: 1001,
                reason: "You must use connect() or refreshToken() first."
            });
        });
    }
    setPaths(paths = []) {
        return __awaiter(this, void 0, void 0, function* () {
            const listPaths = this.pathsTreatment(paths);
            const p = new FormData();
            p.set("setValues", listPaths.join(','));
            if (__classPrivateFieldGet(this, _EventNotificationApi_nonce, "f")) {
                p.set(EventNotificationApi.NONCE_PARAM, __classPrivateFieldGet(this, _EventNotificationApi_nonce, "f"));
            }
            else {
                return this.rejectNoNonce();
            }
            return this.initCall(p);
        });
    }
    addPaths(paths = [], explicitRejectNoRequest = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const listPaths = this.pathsTreatment(paths).filter((generatedPath) => !__classPrivateFieldGet(this, _EventNotificationApi_tempPaths, "f").has(generatedPath) && !__classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f").includes(generatedPath));
            listPaths.forEach((path) => __classPrivateFieldGet(this, _EventNotificationApi_tempPaths, "f").add(path));
            if (listPaths.length == 0) {
                if (explicitRejectNoRequest) {
                    return Promise.reject({
                        status: 1004,
                        reason: "No path to add (can be already listened, or there is already an another request for it)."
                    });
                }
                else {
                    return Promise.resolve(undefined);
                }
            }
            const p = new FormData();
            p.set(EventNotificationApi.ADD_VALUES_PARAMETER, listPaths.join(','));
            if (__classPrivateFieldGet(this, _EventNotificationApi_nonce, "f")) {
                p.set(EventNotificationApi.NONCE_PARAM, __classPrivateFieldGet(this, _EventNotificationApi_nonce, "f"));
            }
            else {
                return this.rejectNoNonce();
            }
            return this.initCall(p);
        });
    }
    removePaths(paths = [], explicitRejectNoRequest = false) {
        return __awaiter(this, void 0, void 0, function* () {
            const input = this.pathsTreatment(paths);
            const listPaths = input.find((generatedPath) => __classPrivateFieldGet(this, _EventNotificationApi_tempPaths, "f").has(generatedPath));
            if (listPaths == undefined)
                return Promise.reject({
                    status: 1005,
                    reason: "One or more paths are in another request. Please try again later."
                });
            const pathsToSend = input.filter((path) => __classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f").includes(path));
            if (pathsToSend.length === 0) {
                if (explicitRejectNoRequest) {
                    return Promise.reject({
                        status: 1006,
                        reason: "No path to remove."
                    });
                }
                else {
                    return Promise.resolve(undefined);
                }
            }
            pathsToSend.forEach((path) => __classPrivateFieldGet(this, _EventNotificationApi_tempPaths, "f").add(path));
            const p = new FormData();
            p.set(EventNotificationApi.REMOVE_VALUES_PARAMETER, pathsToSend.join(','));
            if (__classPrivateFieldGet(this, _EventNotificationApi_nonce, "f")) {
                p.set(EventNotificationApi.NONCE_PARAM, __classPrivateFieldGet(this, _EventNotificationApi_nonce, "f"));
            }
            else {
                return this.rejectNoNonce();
            }
            return this.initCall(p);
        });
    }
    isWebsocketOpen() {
        var _a;
        return (((_a = __classPrivateFieldGet(this, _EventNotificationApi_ws, "f")) === null || _a === void 0 ? void 0 : _a.readyState) === WebSocket.OPEN);
    }
    registerEventNotificationContainer(pc) {
        if (!__classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").has(pc.resCode)) {
            __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").set(pc.resCode, []);
        }
        let tryToAdd = true;
        while (tryToAdd) {
            const rand = this.generateUID();
            if (!__classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(pc.resCode).find(ele => ele.uid)) {
                pc.uid = rand;
                __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(pc.resCode).push(pc);
                return rand;
            }
        }
    }
    removeEventNotificationContainer(resCode, uid) {
        var _a;
        (_a = __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(resCode)) === null || _a === void 0 ? void 0 : _a.forEach((pc, idx) => {
            var _a;
            if (pc.uid == uid) {
                (_a = __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(resCode)) === null || _a === void 0 ? void 0 : _a.splice(idx, 1);
                return;
            }
        });
    }
    getEventNotificationContainer(resCode, uid) {
        const l = __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(resCode);
        const list = (l === undefined) ? [] : l;
        for (const pc of list) {
            if (pc.uid == uid)
                return pc;
        }
        return null;
    }
    registerEventNotification(path, hook) {
        for (const listPath of __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").keys()) {
            if (listPath.rabbitMQPath === path.rabbitMQPath) {
                __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").get(listPath).add(hook);
                return;
            }
        }
        const set = new Set();
        set.add(hook);
        __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").set(path, set);
    }
    removeEventNotification(path, hook) {
        for (const listPath of __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").keys()) {
            if (listPath.rabbitMQPath === path.rabbitMQPath) {
                __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").get(listPath).delete(hook);
                return;
            }
        }
    }
    /**
     * Try to connect if needed.
     * @private
     */
    tryAgain() {
        if (!this.isWebsocketOpen()) {
            this.connectWithStrings(__classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f")).then(r => console.debug("Refresh token open wss. " + r));
        }
        if (__classPrivateFieldGet(this, _EventNotificationApi_countCnxFailure, "f") >= EventNotificationApi._RETRY_AFTER_X_FAILURE) {
            this.connectWithStrings(__classPrivateFieldGet(this, _EventNotificationApi__pathsListened, "f")).then(r => console.debug("Refresh token open wss. " + r));
            __classPrivateFieldSet(this, _EventNotificationApi_countCnxFailure, 0, "f");
        }
    }
    getEventNotification(path) {
        const paths = __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").keys();
        for (const listPath of paths) {
            if (path.rabbitMQPath === listPath.rabbitMQPath) {
                return __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").get(path);
            }
        }
    }
    /**
     * Send notification as observable.
     * @param data data to broadcast to observers
     * @private
     */
    notifyEventNotification(data) {
        var _a;
        try {
            const parsedData = JSON.parse(data); // Convert to exploitable object
            if (!parsedData.hasOwnProperty("path")) {
                return; // If there is no path, abort the broadcast
            }
            if (parsedData.path === "ping") {
                this.computeLastPing(parsedData);
                this.pingReceived = true;
                return;
            } // handle ping
            const pad = this.parsePath(parsedData.path);
            const toBroadCast = {
                crud: pad.crud,
                resId: pad.urlValue,
                res: parsedData === null || parsedData === void 0 ? void 0 : parsedData.res,
                data: parsedData === null || parsedData === void 0 ? void 0 : parsedData.data,
                path: parsedData.path,
                entity: parsedData === null || parsedData === void 0 ? void 0 : parsedData.entity,
                timestamp: Date.now()
            };
            __classPrivateFieldGet(this, _EventNotificationApi_observersList, "f").forEach((v, k) => {
                if (k.compare(toBroadCast.path)) {
                    v.forEach((fun) => {
                        fun(toBroadCast);
                    });
                }
            });
            if (toBroadCast.res !== undefined) {
                (_a = __classPrivateFieldGet(this, _EventNotificationApi_observersListContainer, "f").get(toBroadCast.res)) === null || _a === void 0 ? void 0 : _a.forEach((pc) => {
                    if (pc.resCode == toBroadCast.res) {
                        pc.broadcast(toBroadCast);
                    }
                });
            }
        }
        catch (e) {
            console.error(e);
        }
    }
    /**
     * Parse the path (as string) to get a more machine friendly data
     * @param path rabbitMQ path as string
     * @private
     */
    parsePath(path) {
        var _a;
        const listSections = path.split('.');
        if (listSections.length < 3) {
            return {
                crud: undefined,
                urlValue: undefined,
            };
        }
        else {
            let tc;
            if ((_a = listSections.at(-1)) !== null && _a !== void 0 ? _a : "") {
                tc = listSections.at(-1);
            }
            else {
                tc = undefined;
            }
            return {
                crud: tc,
                urlValue: listSections.at(-2),
            };
        }
    }
    /**
     * Prevent race condition.
     * @param p FormData needed for the POST request
     * @private
     */
    initCall(p) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.callSubscribe(p);
            return __classPrivateFieldGet(this, _EventNotificationApi_pathsErrors, "f");
        });
    }
    /**
     * Create a websocket and add listeners
     * @param nonce nonce associated with this connection
     * @private
     */
    createWebsocket(nonce) {
        __classPrivateFieldSet(this, _EventNotificationApi_ws, new WebSocket(EventNotificationApi.WS_PROTOCOL + EventNotificationApi._URL + EventNotificationApi.WS_ENDPOINT + nonce), "f");
        if (__classPrivateFieldGet(this, _EventNotificationApi_ws, "f") !== null) {
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").onopen = __classPrivateFieldGet(this, _EventNotificationApi_onOp, "f");
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").onclose = __classPrivateFieldGet(this, _EventNotificationApi_onCl, "f");
            __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").onmessage = __classPrivateFieldGet(this, _EventNotificationApi_onMsg, "f");
        }
        if (__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f") !== null) {
            clearInterval(__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f"));
        }
        __classPrivateFieldSet(this, _EventNotificationApi_idSetIntervalPing, setInterval(this.sendPing.bind(this), EventNotificationApi._PING_INTERVAL), "f");
    }
    /**
     * Call the POST endpoint of eventnotification-service and create WS connection.
     * @param body FormData to send
     * @private
     */
    callSubscribe(body) {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            if (__classPrivateFieldGet(this, _EventNotificationApi_jwt, "f") === "") {
                return Promise.reject({
                    status: 401,
                    reason: "No JWT provided for authentication with the backend."
                });
            }
            const res = yield fetch(EventNotificationApi.HTTP_PROTOCOL + EventNotificationApi._URL + EventNotificationApi.SUBSCRIBE_ENDPOINT, {
                method: "POST",
                headers: this.generateFetchHeaders(),
                body: body,
                credentials: "same-origin"
            }).then(response => this.handle401(response));
            __classPrivateFieldGet(this, _EventNotificationApi_tempPaths, "f").clear();
            if (res.ok) {
                const data = yield res.json();
                if (data.paths) {
                    __classPrivateFieldSet(this, _EventNotificationApi__pathsListened, (_a = data.paths) !== null && _a !== void 0 ? _a : [], "f");
                }
                __classPrivateFieldSet(this, _EventNotificationApi_pathsErrors, (_b = data.errors) !== null && _b !== void 0 ? _b : [], "f");
                if (__classPrivateFieldGet(this, _EventNotificationApi_ws, "f") !== null) {
                    if (data.nonce !== __classPrivateFieldGet(this, _EventNotificationApi_nonce, "f")) {
                        __classPrivateFieldGet(this, _EventNotificationApi_ws, "f").close();
                        this.createWebsocket(data.nonce);
                    }
                }
                else {
                    this.createWebsocket(data.nonce);
                }
                __classPrivateFieldSet(this, _EventNotificationApi_nonce, data.nonce, "f");
            }
            else {
                return Promise.reject({
                    status: res.status,
                    reason: yield res.text()
                });
            }
        });
    }
    /**
     * Generate the headers for the fetch function, particularly the Authorization one.
     * @private
     */
    generateFetchHeaders() {
        const headers = new Headers();
        if (__classPrivateFieldGet(this, _EventNotificationApi_jwt, "f") != "") {
            headers.append('Authorization', 'Bearer ' + __classPrivateFieldGet(this, _EventNotificationApi_jwt, "f"));
        }
        return headers;
    }
    /**
     * Convert array of Paths to array of strings, remove duplicate path
     * @param paths list of paths
     * @private
     */
    pathsTreatment(paths) {
        const p = new Set();
        paths.forEach((path) => {
            p.add(path.rabbitMQPath);
        });
        return Array.from(p);
    }
    /**
     * Generate a unique id for this instance.
     * @private
     */
    generateUID() {
        var _a;
        __classPrivateFieldSet(this, _EventNotificationApi_id, (_a = __classPrivateFieldGet(this, _EventNotificationApi_id, "f"), _a++, _a), "f");
        return __classPrivateFieldGet(this, _EventNotificationApi_id, "f").toString();
    }
    /**
     * When the library get unauthorized, cleanup the jwt and stop the ping
     * @param response response of the fetch
     * @private
     */
    handle401(response) {
        if (response.status == 401) {
            if (__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f") !== null) {
                clearInterval(__classPrivateFieldGet(this, _EventNotificationApi_idSetIntervalPing, "f"));
            }
            this.refreshToken("");
        }
        return response;
    }
}
_EventNotificationApi_jwt = new WeakMap(), _EventNotificationApi_ws = new WeakMap(), _EventNotificationApi_nonce = new WeakMap(), _EventNotificationApi__pathsListened = new WeakMap(), _EventNotificationApi_pathsErrors = new WeakMap(), _EventNotificationApi_idSetIntervalPing = new WeakMap(), _EventNotificationApi_tempPaths = new WeakMap(), _EventNotificationApi_countCnxFailure = new WeakMap(), _EventNotificationApi_funcPingOk = new WeakMap(), _EventNotificationApi_funcPingFail = new WeakMap(), _EventNotificationApi_observersList = new WeakMap(), _EventNotificationApi_observersListContainer = new WeakMap(), _EventNotificationApi_id = new WeakMap(), _EventNotificationApi_onMsg = new WeakMap(), _EventNotificationApi_onOp = new WeakMap(), _EventNotificationApi_onCl = new WeakMap();
EventNotificationApi.HTTP_PROTOCOL = "https://";
EventNotificationApi.WS_PROTOCOL = "wss://";
EventNotificationApi._RETRY_AFTER_X_FAILURE = 4;
// URL of the eventNotification service (root)
EventNotificationApi._URL = "localhost:8443/eventnotification"; // "localhost:8443/eventnotification"; //"https://api.dev.centralize.equisoft.io/eventnotification";
// Ping interval (in ms)
EventNotificationApi._PING_INTERVAL = 5000;
// subscribe endpoint parameter
EventNotificationApi.NONCE_PARAM = "nonce";
EventNotificationApi.ADD_VALUES_PARAMETER = "addValues";
EventNotificationApi.REMOVE_VALUES_PARAMETER = "removeValues";
EventNotificationApi.SET_VALUES_PARAMETER = "setValues";
// Relative path for the Websocket endpoint
EventNotificationApi.WS_ENDPOINT = "/";
// Relative path for the subscription endpoint
EventNotificationApi.SUBSCRIBE_ENDPOINT = "/subscribe";
// Relative path for the logout endpoint
EventNotificationApi.LOGOUT_ENDPOINT = "/subscribe/logout/";
// regex allowing to check if the syntax of the path is valid.
EventNotificationApi.REGEX_PATTERN = new RegExp("^[A-Za-z0-9.*#]*$");
export default new EventNotificationApi();
